<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between start" style="align-items: flex-start;">
  <span class="smaller-font" [style.fontSize.px]="layout?.isMobile ? 12 : 14">{{data.title}}</span>
  <button mat-icon-button class="close-button" type="button" (click)="dialogRef.close(false)" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="dialog-content">
  <form [formGroup]="classesForm" *ngIf="classesForm">
    <div formArrayName="classes">
      <div class="mobile-classes-list" *ngIf="layout?.isMobile">
        <mat-card class="mobile-class-card" *ngFor="let row of classesRows; let rowIndex = index">
          <div class="mobile-class-head">
            <strong>#{{ rowIndex + 1 }}</strong>
            <span fxFlex></span>
            <button mat-icon-button color="primary" *ngIf="!isEditableClasse[rowIndex]" (click)="editClasse(rowIndex)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="primary" *ngIf="isEditableClasse[rowIndex]" (click)="saveClasse(rowIndex)">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="removeClasse(rowIndex)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div [formGroupName]="rowIndex">
            <ng-container *ngIf="!isEditableClasse[rowIndex]">
              <div class="mobile-class-line">
                <span>Classificação</span>
                <strong>{{
                  (row.get('financClassificacaoG')?.value?.classificacao ? row.get('financClassificacaoG')?.value?.classificacao.toString().padStart(6, '0') + ' - ' : '') +
                  (row.get('financClassificacaoG')?.value?.descricao || '')
                }}</strong>
              </div>
              <div class="mobile-class-grid">
                <div>
                  <span>Natureza</span>
                  <strong>{{ row.get('natureza')?.value }}</strong>
                </div>
                <div>
                  <span>Valor</span>
                  <strong>{{ row.get('valor')?.value | number:'1.2-2' }}</strong>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="isEditableClasse[rowIndex]">
              <mat-form-field class="full-width">
                <mat-label>Classificação</mat-label>
                <mat-select [formControl]="row.get('financClassificacaoG')" (selectionChange)="onSelectionChangeClasse(rowIndex, $event)">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="row.get('searchClassificacao')"
                      placeholderLabel="Pesquisar Classificação"
                      noEntriesFoundLabel="Classificação não encontrado"
                      [searching]="searching">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let c of classificacoes" [value]="c">
                    <span>{{ (c?.classificacao ? c.classificacao.toString().padStart(6, '0') + ' - ' : '') + (c?.descricao || '') }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="full-width">
                <mat-label>Valor</mat-label>
                <input matInput formControlName="valor" currencyMask
                  (focus)="armClassValueReplace($event)"
                  (keydown)="applyClassValueReplaceOnFirstKey($event, rowIndex)"
                  (blur)="disarmClassValueReplace($event)"
                  [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" />
              </mat-form-field>
            </ng-container>
          </div>
        </mat-card>
      </div>

      <ng-container *ngIf="!layout?.isMobile">
      <ngx-datatable class="material ml-0 mr-0"
        [rows]="classesRows"
        [headerHeight]="50"
        [footerHeight]="50"
        [messages]="{emptyMessage:'Nenhuma Classe/Centro de Custo encontrado'}"
        [limit]="10"
        [rowHeight]="50">

        <ngx-datatable-column name="#" [width]="25">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex+1 }}</strong>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Classificação/Centro de Custo" [minWidth]="550" [maxWidth]="750">
          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div [formGroupName]="rowIndex">
              <ng-container *ngIf="!isEditableClasse[rowIndex]">
                <input matInput [value]="
                  (row.get('financClassificacaoG')?.value?.classificacao ? row.get('financClassificacaoG')?.value?.classificacao.toString().padStart(6, '0') + ' - ' : '') +
                  (row.get('financClassificacaoG')?.value?.descricao || '')
                " placeholder="classificação" readonly />
              </ng-container>
              <ng-container *ngIf="isEditableClasse[rowIndex]">
                <mat-form-field appearance="full-width" class="full-width">
                  <mat-label>Classificação</mat-label>
                  <mat-select [formControl]="row.get('financClassificacaoG')" (selectionChange)="onSelectionChangeClasse(rowIndex, $event)">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="row.get('searchClassificacao')"
                        placeholderLabel="Pesquisar Classificação"
                        noEntriesFoundLabel="Classificação não encontrado"
                        [searching]="searching">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let c of classificacoes" [value]="c">
                      <span>
                        {{
                          (c?.classificacao ? c.classificacao.toString().padStart(6, '0') + ' - ' : '') +
                          (c?.descricao || '')
                        }}
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Natureza" [minWidth]="150" [maxWidth]="200">
          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div [formGroupName]="rowIndex">
              <input matInput formControlName="natureza" placeholder="Natureza" readonly />
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Valor" [minWidth]="150" [maxWidth]="200">
          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div [formGroupName]="rowIndex">
              <ng-container *ngIf="!isEditableClasse[rowIndex]">
                <input matInput formControlName="valor" readonly currencyMask
                  [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" />
              </ng-container>
              <ng-container *ngIf="isEditableClasse[rowIndex]">
                <mat-form-field class="full-width">
                  <input matInput formControlName="valor" currencyMask
                    (focus)="armClassValueReplace($event)"
                    (keydown)="applyClassValueReplaceOnFirstKey($event, rowIndex)"
                    (blur)="disarmClassValueReplace($event)" appOnReturn
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" />
                </mat-form-field>
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Ações" [minWidth]="100" [maxWidth]="150">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <button mat-icon-button color="primary" *ngIf="!isEditableClasse[rowIndex]" (click)="editClasse(rowIndex)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="success" *ngIf="isEditableClasse[rowIndex]" (click)="saveClasse(rowIndex)">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="removeClasse(rowIndex)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
      </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="mt-2 total-row" style="margin-left: 8px;">
      <strong style="font-size: 1.1em;">
        Total Lançado (Saldo): {{ totalClasses != null ? (totalClasses | number:'1.2-2') : '0,00' }}
        <ng-container *ngIf="totalClasses != null && financRp?.valor != null">
          <ng-container *ngIf="totalClasses < financRp.valor">
            &nbsp;|&nbsp; Diferença: {{ (financRp.valor - totalClasses) | number:'1.2-2' }}
          </ng-container>
          <ng-container *ngIf="totalClasses > (financRp.valor ?? 0)">
            &nbsp;|&nbsp;
            <span style="color: red;">
              Diferença: {{ (totalClasses - (financRp.valor ?? 0)) | number:'1.2-2' }}
            </span>
          </ng-container>
        </ng-container>
      </strong>
    </div>
    <div class="actions-row">
      <button mat-raised-button color="primary" (click)="addClasse()">
        <mat-icon>add</mat-icon>
        Adicionar Classe/Centro de Custo
      </button>
    </div>
  </form>
</div>